<template>
  <div>
    <validation-observer ref="observer" v-slot="{ passes }">
      <validation-provider
        name="Nome"
        :rules="{ required: true, min: 4 }"
        v-slot="validationContext"
      >
        <v-text-field
          solo
          label="Seu nome"
          :state="getValidationState(validationContext)"
          :error-messages="validationContext.errors[0]"
          required
          v-model="name"
        />
      </validation-provider>
      <validation-provider
        name="E-mail"
        :rules="{ required: true, email: true }"
        v-slot="validationContext"
      >
        <v-text-field
          solo
          label="Seu e-mail"
          :state="getValidationState(validationContext)"
          :error-messages="validationContext.errors[0]"
          required
          v-model="email"
        />
      </validation-provider>
      <validation-provider
        name="Assunto"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <v-text-field
          solo
          label="Assunto"
          :state="getValidationState(validationContext)"
          :error-messages="validationContext.errors[0]"
          required
          v-model="subject"
        />
      </validation-provider>
      <validation-provider
        name="Mensagem"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <v-textarea
          solo
          label="Sua mensagem"
          :state="getValidationState(validationContext)"
          :error-messages="validationContext.errors[0]"
          required
          v-model="text"
        />
      </validation-provider>
      <v-btn
        color="#25C135"
        dark
        class="float-right"
        @click.stop.prevent="passes(send)"
        :disabled="isLoading"
      >
        <span v-if="!isLoading"> Entrar em contato </span>
        <span v-else class="mr-2"> Enviando... </span>
        <v-progress-circular indeterminate color="grey" v-if="isLoading" />
      </v-btn>
    </validation-observer>
  </div>
</template>
<script>
import { request } from "@/infrastructure/http";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      name: null,
      email: null,
      subject: null,
      text: null,
      to: process.env.VUE_APP_RECEIPT_EMAIL,
      isLoading: false
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    send() {
      this.isLoading = true;
      request
        .post("/send", {
          text: `Email recebido do site,enviado por ${name} <${this.email}>\n\n${this.text}`,
          subject: this.subject,
          name: this.name,
          to: this.to
        })
        .then(() => {
          this.isLoading = false;
          Swal.fire({
            title: "Sucesso",
            text: "E-mail enviado com sucesso, nós da Drell agradecemos seu contato e em breve entraremos em contato!",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#46c763"
          });
        })
        .catch(() => {
          this.isLoading = false;
          Swal.fire({
            title: "Oops...",
            text: "Tente novamente mais tarde",
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: "#f27474"
          });
        });
    }
  }
};
</script>
